import styled from 'styled-components';

export const Wrapper = styled.div``;

export const LogoWrapper = styled.div`
  padding: 32px 8px 0;
`;
